import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import ListRow from './ListRow.js';
import {
  addColorSampleItem,
  addNewOrderCustomItem,
} from 'services/store/actions/newOrder';

const Th = styled.th`
  vertical-align: middle;
  width: 50px;
  background-color: ${({ side, theme }) => {
    if (side === 'left') return theme.blowWarning;
    if (side === 'right') return theme.blowGreen;
  }};
`;

const List = () => {
  const dispatch = useDispatch();
  const order = useSelector((state) => state.newOrder);

  useEffect(() => {
    if (!order.colorSamplesItems.length) dispatch(addColorSampleItem());
  }, []);

  return (
    <>
      <Table striped bordered hover size="sm" responsive="md">
        <thead>
          <tr>
            <Th>Lp</Th>
            <th style={{ width: 200 }}>Typ</th>
            <Th>Ilość</Th>
            <th style={{ width: 600 }}>Uwagi</th>
          </tr>
        </thead>
        <tbody>
          {order.colorSamplesItems.map((item, index) => (
            <ListRow key={index} item={item} index={index} />
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default List;
